// extracted by mini-css-extract-plugin
module.exports = {"Title":"ConfirmationDialog_Title__3uBe8","ButtonContainer":"ConfirmationDialog_ButtonContainer__39ZWd"};